module.exports = __webpack_public_path__ + "static/media/off_stream.886bedd9.svg";